import ScriptsPage from './ScriptsPage'

export default ScriptsPage